import * as React from 'react';

export interface IT2IconProps {
  color?: string;
  size?: string | number;
  title?: string;
}

export const T2Icon = React.forwardRef<SVGSVGElement, IT2IconProps>(
  ({ color = 'currentColor', size = '1em', title = null, ...rest }, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={size}
        height={size}
        fill={color}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <g xmlns="http://www.w3.org/2000/svg" transform="matrix(1.0404,0,0,1.0404,-98.016,-47.497)">
          <g fontFamily="sans-serif" fontSize="10.583px" wordSpacing="0px" aria-label="T 1">
            <g
              transform="matrix(.92985 0 0 .86537 6.8704 6.826)"
              fontFamily="sans-serif"
              fontSize="10.583px"
              aria-label="T1"
            >
              <g
                transform="matrix(3.0828,0,0,3.3126,-203.5,-95.579)"
                fontFamily="sans-serif"
                fontSize="8.652px"
                strokeWidth=".0072031"
                aria-label="T1"
              >
                <text x="97.087555" y="47.709003" fontFamily="sans-serif" fontSize="4.6513px" xmlSpace="preserve">
                  <tspan x="97.087555" y="47.709003" strokeWidth=".0072031" />
                </text>
                <g aria-label="T1">
                  <path d="m96.966 43.283q0-0.19967 0.19967-0.19967h1.9967q0.19967 0 0.19967 0.19967t-0.19967 0.19967h-0.79867v3.3943q0 0.19967-0.19967 0.19967t-0.19967-0.19967v-3.3943h-0.79867q-0.19967 0-0.19967-0.19967z" />
                  <g transform="matrix(.88685 0 0 1.1276 .054846 -.0091407)" strokeWidth=".0027234" aria-label="2">
                    <path
                      d="m113.28 38.179q0.41096 0 0.69893 0.26503 0.29098 0.2623 0.29098 0.63662 0 0.25684-0.17999 0.51913l-1.2478 1.8252h1.2298q0.19799 0 0.19799 0.18033t-0.19799 0.18033h-1.5838q-0.19798 0-0.19798-0.18033 0-0.05465 0.0331-0.10383l1.4518-2.123q0.099-0.14481 0.099-0.29782 0-0.22405-0.17398-0.38252t-0.41996-0.15847q-0.33596 0-0.62094 0.45356-0.054 0.08743-0.17098 0.08743-0.19798 0-0.19798-0.18033 0-0.04098 0.018-0.07377 0.36897-0.64755 0.97191-0.64755z"
                      strokeWidth=".0028536"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  },
);
